import React from 'react';
import video from './intro-movie-web-small.mp4';
import { styled } from '../../themes';
import Button from '../buttons';
import { device } from 'themes/media-queries';

interface Props {
  title: string;
  buttonLabel: string;
  buttonUrl: string;
}

const CTA = (props: Props) => {
  const { title, buttonLabel, buttonUrl } = props;
  return (
    <Wrapper>
      <video
        autoPlay
        loop
        playsInline
        muted
        width={'100%'}
        height={'100%'}
        style={{ minHeight: '400px', objectFit: 'cover' }}
      >
        <source type="video/mp4" src={video} />
      </video>
      <Container>
        <Overlay />
        <Content>
          <Heading>{title}</Heading>
          <CTAButton label={buttonLabel} to={buttonUrl} />
        </Content>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: block;
`;

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 5px; /* Needed to hide weird whitespace */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-image: linear-gradient(
    243deg,
    rgba(43, 44, 61, 0),
    rgba(187, 97, 23, 0.25) 44%,
    #2b2c3d
  );
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 10;
`;

const Heading = styled.h2`
  color: white;
  text-align: center;
  margin-bottom: 2.5rem;

  @media ${device.mobileL} {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }
`;

const CTAButton = styled(Button)``;

export default CTA;
